import {
  dashboardPathForSection,
  dashboardSectionFromPathSegment,
  defaultDashboardContentType,
} from "@dashboard/routes/dashboard-navigation"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboard-host"
import { currentRequestHostname } from "@utils/dashboard-host-runtime"
import { lazy, Suspense } from "react"

const DashboardApp = lazy(() =>
  import("@dashboard/routes/DashboardApp").then((module) => ({ default: module.DashboardApp }))
)

export const Route = createFileRoute("/dashboard/$section")({
  component: DashboardSectionRoute,
  beforeLoad: async ({ location, params }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })

    const section = dashboardSectionFromPathSegment(params.section)
    if (!section) {
      throw redirect({ href: dashboardPathForSection(defaultDashboardContentType) })
    }
  },
})

function DashboardSectionRoute() {
  const { section } = Route.useParams()
  const dashboardSection = dashboardSectionFromPathSegment(section) ?? defaultDashboardContentType

  return (
    <Suspense fallback={<div className="dashboard-loading">Loading dashboard...</div>}>
      <DashboardApp activeSection={dashboardSection} />
    </Suspense>
  )
}
